/* eslint-disable */
// import jwtInterceptor from "../Shared/jwtInterceptor";
import store from "../../store/index";
import axios from "axios";

export default {
  name: "newtemplate",

  props: {
    closeoption: { type: String, default: "" },
    formsesid:   { type: String, default: "" },
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      showpopup: true,
      formsid: "",
      previousRoute: null,
    };
  },

  computed: {
    // Map incoming closeoption prop to what the child should receive.
    mappedCloseOption() {
      switch (this.closeoption) {
        case "forms":               return "listform";
        case "sitesummary":         return "sitesummary";
        case "home":                return "home";
        case "patientlist":         return "patientlist";
        case "PatientScheduleView": return "PatientScheduleView";
        case "submitForm":          return "submitForm";
        default:                    return this.closeoption || "";
      }
    },
  },

  watch: {
    // Keep local formsid synced with the parent's formsesid immediately
    formsesid: {
      immediate: true,
      handler(v) { this.formsid = v; },
    },
  },

  // No need to set formsid in beforeMount; the watcher above handles it.

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = { name: from?.name || null };
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.fullPath !== "/submitForm")        store.dispatch("setopentreeforsubmitForm", false);
    if (to.fullPath !== "/subject_schedule")  store.dispatch("setopentreeforsubjectschedule", false);
    if (to.fullPath !== "/eproSubjects")      store.dispatch("setopentreeforeprosubjects", false);
    next();
  },

  mounted() {
    // Reopen trees based on where we came from
    if (this.previousRoute?.name === "eproSubjects")
      store.dispatch("setopentreeforeprosubjects", true);
    if (this.previousRoute?.name === "submitForm")
      store.dispatch("setopentreeforsubmitForm", true);
    if (this.previousRoute?.name === "subject_schedule")
      store.dispatch("setopentreeforsubjectschedule", true);

    // Helpful log
    console.log(
      "closeoption prop:", this.closeoption,
      "→ child receives:", this.mappedCloseOption
    );
  },

  methods: {
    async setunverified() {
      console.log("unverified " + this.formsid);
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.put(
          `${this.baseurl}/forms/forms/unverifyformstatus`,
          { formId: this.formsid },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("form unverified ", res);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
